export default __webpack_public_path__ + "static/media/journeytray-greentree-nutflower.efefb592.svg";